import React, { ReactNode } from 'react'
import { Box, Typography } from '@material-ui/core'

type AccordionInfoProps = {
  icon: ReactNode,
  title: string,
  description: string
}

export const AccordionInfo: React.FC<AccordionInfoProps> = (props) => {
  const { title, description, icon } = props

  return (
    <Box sx={{
      display: 'flex',
      gap: 2
    }}>
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 52,
        height: 52,
        borderRadius: 1,
        backgroundColor: '#F8F8F8'
      }}>
        {icon}
      </Box>
      <Box sx={{
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Typography variant='airbnbH5'>{title}</Typography>
        <Typography variant='airbnbBody1' color='textGray2.main'>{description}</Typography>
      </Box>
    </Box>
  )
}
